/**
 * Schedule Utilities for Kioo Radio
 * Determines the currently playing program based on time and day
 */

// Complete schedule data (same as Programs.js)
const weekdaySchedule = [
  { "Start Time": "00:00", "End Time": "00:30", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "00:30", "End Time": "01:00", "Program": "Community Announcements", "Language": "English", "Type": "Community" },
  { "Start Time": "01:00", "End Time": "01:30", "Program": "Phone-in Program", "Language": "English", "Type": "Interactive" },
  { "Start Time": "01:30", "End Time": "02:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "02:00", "End Time": "02:30", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "02:30", "End Time": "03:00", "Program": "Music & Reflection", "Language": "Kissi", "Type": "Music" },
  { "Start Time": "03:00", "End Time": "03:30", "Program": "Community Announcements", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "03:30", "End Time": "04:00", "Program": "Phone-in Program", "Language": "Kissi", "Type": "Interactive" },
  { "Start Time": "04:00", "End Time": "04:25", "Program": "Community Programming", "Language": "French", "Type": "Community" },
  { "Start Time": "04:25", "End Time": "04:26", "Program": "Focus Famille", "Language": "French", "Type": "Famille" },
  { "Start Time": "04:26", "End Time": "04:55", "Program": "Community Programming", "Language": "French", "Type": "Community" },
  { "Start Time": "04:55", "End Time": "04:56", "Program": "Share Life Africa", "Language": "French", "Type": "Dévotion" },
  { "Start Time": "04:56", "End Time": "05:00", "Program": "Music & Reflection", "Language": "French", "Type": "Music" },
  { "Start Time": "05:00", "End Time": "05:15", "Program": "Morning Devotional", "Language": "English", "Type": "Devotional" },
  { "Start Time": "05:15", "End Time": "05:45", "Program": "Morning Prayer & Worship", "Language": "English", "Type": "Worship" },
  { "Start Time": "05:45", "End Time": "06:00", "Program": "Community Announcements", "Language": "English", "Type": "Community" },
  { "Start Time": "06:00", "End Time": "06:30", "Program": "Thru the Bible (TTB)", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "06:30", "End Time": "07:00", "Program": "Daily Sermon", "Language": "English", "Type": "Sermon" },
  { "Start Time": "07:00", "End Time": "07:30", "Program": "Love & Faith", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "07:30", "End Time": "08:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "08:00", "End Time": "08:30", "Program": "Thru the Bible (TTB)", "Language": "Kissi", "Type": "Bible Teaching" },
  { "Start Time": "08:30", "End Time": "09:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "09:00", "End Time": "10:00", "Program": "VNA French Satellite Feed", "Language": "French", "Type": "Satellite" },
  { "Start Time": "10:00", "End Time": "10:30", "Program": "Pastor's Corner - Liberia", "Language": "English", "Type": "Sermon" },
  { "Start Time": "10:30", "End Time": "11:00", "Program": "Spot Light English", "Language": "English", "Type": "Educational" },
  { "Start Time": "11:00", "End Time": "11:05", "Program": "Guidelines for Living", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "11:05", "End Time": "11:30", "Program": "Community Announcements", "Language": "English", "Type": "Community" },
  { "Start Time": "11:30", "End Time": "11:32", "Program": "Reset by Bonnie Sala", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "11:32", "End Time": "12:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "12:00", "End Time": "12:30", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "12:30", "End Time": "13:00", "Program": "Youth Connect", "Language": "Kissi", "Type": "Youth/Community" },
  { "Start Time": "13:00", "End Time": "13:30", "Program": "Community Announcements", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "13:30", "End Time": "14:00", "Program": "Phone-in Program", "Language": "Kissi", "Type": "Interactive" },
  { "Start Time": "14:00", "End Time": "14:30", "Program": "Thru the Bible (TTB)", "Language": "French", "Type": "Bible Teaching" },
  { "Start Time": "14:30", "End Time": "15:00", "Program": "Pastor's Corner - Sierra Leone", "Language": "English", "Type": "Sermon" },
  { "Start Time": "15:00", "End Time": "15:30", "Program": "Music & Reflection", "Language": "Mixed", "Type": "Music" },
  { "Start Time": "15:30", "End Time": "15:35", "Program": "Guidelines for Living", "Language": "French", "Type": "Bible Teaching" },
  { "Start Time": "15:35", "End Time": "16:00", "Program": "Music & Reflection", "Language": "French", "Type": "Music" },
  { "Start Time": "16:00", "End Time": "17:00", "Program": "Christian Teaching", "Language": "Mandingo", "Type": "Bible Teaching", "friday_override": { "Program": "Renaissance", "Language": "French", "Type": "Interactive" } },
  { "Start Time": "17:00", "End Time": "17:30", "Program": "Christian Teaching", "Language": "Fula", "Type": "Bible Teaching" },
  { "Start Time": "17:30", "End Time": "18:00", "Program": "Community Programming", "Language": "Fula", "Type": "Community" },
  { "Start Time": "18:00", "End Time": "18:02", "Program": "Reset by Bonnie Sala", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "18:02", "End Time": "19:00", "Program": "Evening News & Roundup", "Language": "Mixed", "Type": "Community", "friday_override": { "Program": "Women's Empowerment Hour", "Language": "Mixed", "Type": "Community" } },
  { "Start Time": "19:00", "End Time": "19:30", "Program": "Pastor's Corner - Guinea", "Language": "French", "Type": "Sermon", "monday_override": { "Program": "Gbandi Language Hour", "Language": "Gbandi", "Type": "Community" } },
  { "Start Time": "19:30", "End Time": "20:00", "Program": "Community Programming", "Language": "French", "Type": "Community", "monday_override": { "Program": "Gbandi Language Hour (continued)", "Language": "Gbandi", "Type": "Community" } },
  { "Start Time": "20:00", "End Time": "20:30", "Program": "Thru the Bible (TTB)", "Language": "Kissi", "Type": "Bible Teaching" },
  { "Start Time": "20:30", "End Time": "21:00", "Program": "Phone-in Program", "Language": "Kissi", "Type": "Interactive" },
  { "Start Time": "21:00", "End Time": "21:30", "Program": "Thru the Bible (TTB)", "Language": "English", "Type": "Bible Teaching" },
  { "Start Time": "21:30", "End Time": "22:00", "Program": "Pastor's Corner - Multi-Country", "Language": "Mixed", "Type": "Sermon" },
  { "Start Time": "22:00", "End Time": "22:02", "Program": "Reset by Bonnie Sala", "Language": "French", "Type": "Bible Teaching" },
  { "Start Time": "22:02", "End Time": "22:30", "Program": "Thru the Bible (TTB)", "Language": "French", "Type": "Bible Teaching" },
  { "Start Time": "22:30", "End Time": "23:00", "Program": "Community Announcements", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "23:00", "End Time": "23:30", "Program": "Music & Reflection", "Language": "Mixed", "Type": "Music" },
  { "Start Time": "23:30", "End Time": "00:00", "Program": "Evening Devotional", "Language": "Mixed", "Type": "Devotional" }
];

const saturdaySchedule = [
  { "Start Time": "00:00", "End Time": "01:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "01:00", "End Time": "02:00", "Program": "Community Programming", "Language": "English", "Type": "Community" },
  { "Start Time": "02:00", "End Time": "03:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "03:00", "End Time": "04:00", "Program": "Music & Reflection", "Language": "Kissi", "Type": "Music" },
  { "Start Time": "04:00", "End Time": "05:00", "Program": "Community Programming", "Language": "French", "Type": "Community" },
  { "Start Time": "05:00", "End Time": "06:00", "Program": "Morning Prayer & Worship", "Language": "English", "Type": "Worship" },
  { "Start Time": "06:00", "End Time": "09:00", "Program": "Makona Talk Show", "Language": "English, French & Kissi", "Type": "Interactive" },
  { "Start Time": "09:00", "End Time": "10:00", "Program": "VNA French Satellite Feed", "Language": "French", "Type": "Satellite" },
  { "Start Time": "10:00", "End Time": "11:00", "Program": "Community Programming", "Language": "English", "Type": "Community" },
  { "Start Time": "11:00", "End Time": "12:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "12:00", "End Time": "13:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "13:00", "End Time": "14:00", "Program": "Youth Connect Special", "Language": "English", "Type": "Youth/Community" },
  { "Start Time": "14:00", "End Time": "14:40", "Program": "Découverte de la Bible – Série Jeunesse", "Language": "French", "Type": "Jeunesse" },
  { "Start Time": "14:40", "End Time": "15:00", "Program": "Music & Reflection", "Language": "French", "Type": "Music" },
  { "Start Time": "15:00", "End Time": "16:00", "Program": "Community Programming", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "16:00", "End Time": "17:00", "Program": "Music & Reflection", "Language": "Mixed", "Type": "Music" },
  { "Start Time": "17:00", "End Time": "18:00", "Program": "Community Programming", "Language": "Fula", "Type": "Community" },
  { "Start Time": "18:00", "End Time": "19:00", "Program": "Evening News & Roundup", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "19:00", "End Time": "20:00", "Program": "Pastor's Corner - Weekend", "Language": "French", "Type": "Sermon" },
  { "Start Time": "20:00", "End Time": "21:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "21:00", "End Time": "22:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "22:00", "End Time": "23:00", "Program": "Community Announcements", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "23:00", "End Time": "00:00", "Program": "Evening Devotional", "Language": "Mixed", "Type": "Devotional" }
];

const sundaySchedule = [
  { "Start Time": "00:00", "End Time": "01:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "01:00", "End Time": "02:00", "Program": "Community Programming", "Language": "English", "Type": "Community" },
  { "Start Time": "02:00", "End Time": "03:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "03:00", "End Time": "04:00", "Program": "Music & Reflection", "Language": "Kissi", "Type": "Music" },
  { "Start Time": "04:00", "End Time": "05:00", "Program": "Community Programming", "Language": "French", "Type": "Community" },
  { "Start Time": "05:00", "End Time": "06:00", "Program": "Morning Prayer & Worship", "Language": "English", "Type": "Worship" },
  { "Start Time": "06:00", "End Time": "07:00", "Program": "Sunday Service Prep", "Language": "English", "Type": "Worship" },
  { "Start Time": "07:00", "End Time": "10:00", "Program": "Live Sunday Service", "Language": "Mixed", "Type": "Live Service" },
  { "Start Time": "10:00", "End Time": "11:00", "Program": "Post-Service Reflection", "Language": "English", "Type": "Worship" },
  { "Start Time": "11:00", "End Time": "12:00", "Program": "Music & Reflection", "Language": "English", "Type": "Music" },
  { "Start Time": "12:00", "End Time": "13:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "13:00", "End Time": "14:00", "Program": "Youth Connect Sunday", "Language": "English", "Type": "Youth/Community" },
  { "Start Time": "14:00", "End Time": "15:00", "Program": "La Vie Chez Nous", "Language": "French", "Type": "Interactive" },
  { "Start Time": "15:00", "End Time": "16:00", "Program": "Community Programming", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "16:00", "End Time": "17:00", "Program": "Music & Reflection", "Language": "Mixed", "Type": "Music" },
  { "Start Time": "17:00", "End Time": "18:00", "Program": "Community Programming", "Language": "Fula", "Type": "Community" },
  { "Start Time": "18:00", "End Time": "19:00", "Program": "Evening News & Roundup", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "19:00", "End Time": "20:00", "Program": "Pastor's Corner - Sunday", "Language": "French", "Type": "Sermon" },
  { "Start Time": "20:00", "End Time": "21:00", "Program": "Community Programming", "Language": "Kissi", "Type": "Community" },
  { "Start Time": "21:00", "End Time": "22:00", "Program": "Sunday Evening Worship", "Language": "English", "Type": "Worship" },
  { "Start Time": "22:00", "End Time": "23:00", "Program": "Community Announcements", "Language": "Mixed", "Type": "Community" },
  { "Start Time": "23:00", "End Time": "00:00", "Program": "Evening Devotional", "Language": "Mixed", "Type": "Devotional" }
];

/**
 * Convert time string to minutes since midnight
 */
const timeToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

/**
 * Get the day name from a date
 */
const getDayName = (date) => {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  return days[date.getDay()];
};

/**
 * Get the appropriate schedule for a given day (case-insensitive).
 * Accepts short/long names: 'monday', 'Sunday', 'sat', etc.
 * Applies any *_override entries (e.g. friday_override, monday_override).
 */
export const getScheduleForDay = (dayName) => {
  const d = String(dayName || '').toLowerCase();
  let base;
  if (d.startsWith('sat')) base = saturdaySchedule;
  else if (d.startsWith('sun')) base = sundaySchedule;
  else base = weekdaySchedule;

  const overrideKey = `${d}_override`;
  return base.map((slot) => {
    if (slot[overrideKey]) {
      return { ...slot, ...slot[overrideKey] };
    }
    // Strip any *_override fields so we don't leak them to the UI
    const { friday_override, monday_override, ...rest } = slot;
    return rest;
  });
};

/**
 * Get the current program based on GMT time
 * @returns {Object} Current program info including name, language, type, time slot, and next program
 */
export const getCurrentProgram = () => {
  // Get current GMT time
  const now = new Date();
  const gmtTime = new Date(now.toLocaleString('en-US', { timeZone: 'GMT' }));
  const dayName = getDayName(gmtTime);
  const currentMinutes = gmtTime.getHours() * 60 + gmtTime.getMinutes();
  
  // Get the right schedule
  const schedule = getScheduleForDay(dayName);
  
  // Find current program
  let currentProgram = null;
  let nextProgram = null;
  
  for (let i = 0; i < schedule.length; i++) {
    const program = schedule[i];
    const startMinutes = timeToMinutes(program['Start Time']);
    let endMinutes = timeToMinutes(program['End Time']);
    
    // Handle midnight crossing
    if (endMinutes === 0) endMinutes = 24 * 60;
    
    if (currentMinutes >= startMinutes && currentMinutes < endMinutes) {
      // Check for day-specific override
      const overrideKey = `${dayName}_override`;
      if (program[overrideKey]) {
        currentProgram = {
          ...program,
          ...program[overrideKey],
          startTime: program['Start Time'],
          endTime: program['End Time']
        };
      } else {
        currentProgram = {
          name: program.Program,
          language: program.Language,
          type: program.Type,
          startTime: program['Start Time'],
          endTime: program['End Time']
        };
      }
      
      // Get next program
      if (i + 1 < schedule.length) {
        const next = schedule[i + 1];
        const nextOverrideKey = `${dayName}_override`;
        if (next[nextOverrideKey]) {
          nextProgram = {
            name: next[nextOverrideKey].Program,
            language: next[nextOverrideKey].Language,
            startTime: next['Start Time']
          };
        } else {
          nextProgram = {
            name: next.Program,
            language: next.Language,
            startTime: next['Start Time']
          };
        }
      }
      break;
    }
  }
  
  // If no program found (edge case), return first program
  if (!currentProgram && schedule.length > 0) {
    const first = schedule[0];
    currentProgram = {
      name: first.Program,
      language: first.Language,
      type: first.Type,
      startTime: first['Start Time'],
      endTime: first['End Time']
    };
  }
  
  return {
    current: currentProgram,
    next: nextProgram,
    gmtTime: gmtTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false }),
    dayName: dayName.charAt(0).toUpperCase() + dayName.slice(1)
  };
};

/**
 * Get language flag/emoji for display
 */
export const getLanguageFlag = (language) => {
  const flags = {
    'English': '🇬🇧',
    'French': '🇫🇷',
    'Kissi': '🇱🇷',
    'Fula': '🇬🇳',
    'Mandingo': '🇸🇱',
    'Gbandi': '🇱🇷',
    'Mixed': '🌍',
    'English, French & Kissi': '🌍'
  };
  return flags[language] || '🎙️';
};

/**
 * Get program type icon
 */
export const getProgramTypeIcon = (type) => {
  const icons = {
    'Music': '🎵',
    'Community': '👥',
    'Interactive': '📞',
    'Worship': '🙏',
    'Bible Teaching': '📖',
    'Sermon': '⛪',
    'Devotional': '✝️',
    'Satellite': '📡',
    'Educational': '📚',
    'Youth/Community': '👦',
    'Live Service': '🔴',
    'Magazine': '📰',
    'Missions': '🌍',
    'Famille': '👨‍👩‍👧‍👦',
    'Dévotion': '🕯️',
    'Jeunesse': '🧑‍🤝‍🧑'
  };
  return icons[type] || '📻';
};

export default getCurrentProgram;
